import React, { useContext, useRef, useState, useEffect } from "react";
import { Play, Pause, RotateCw, Share } from "lucide-react";
// import "./AudioPlayer.css"; // Import the custom CSS
import { RiForward30Line } from "react-icons/ri";
import { RiReplay30Fill } from "react-icons/ri";
import { IoShareSocialOutline } from "react-icons/io5";
import { ApiContext } from "../context/ApiContext";

const AudioPlayer2 = () => {


  const [interviewsspeed, setinterviewsspeed] = useState(1);

  const [showDropdown, setShowDropdown] = useState(false);
  const { interviewsaudioRef, currentTime55, setCurrentTime55, duration55, setDuration55, audioSrc555, interviewsisPlaying, interviewstogglePlayPause } = useContext(ApiContext);

  useEffect(() => {
    if (audioSrc555) {
      setCurrentTime55(0);
      setDuration55(0);
      // setIsMetadataLoading(true);
    }
  }, [audioSrc555]);



  // const interviewshandleinterviewsspeedChange = () => {
  //   const newinterviewsspeed = interviewsspeed === 1 ? 0.75 : 1;
  //   interviewsaudioRef.current.playbackRate = newinterviewsspeed;
  //   setinterviewsspeed(newinterviewsspeed);
  // };
  const interviewshandleinterviewsspeedChange = (newinterviewsspeed) => {
    interviewsaudioRef.current.playbackRate = newinterviewsspeed;
    setinterviewsspeed(newinterviewsspeed);
    setShowDropdown(false);
  };

  const interviewsspeedOptions = [2, 1.75, 1.5, 1.25, 1, 0.75];


  const interviewshandleSeek = (e) => {
    const newTime = (e.target.value * duration55) / 100; // Changed variable name
    interviewsaudioRef.current.currentTime = newTime;
    setCurrentTime55(newTime); // Changed variable name
  };

  const interviewshandleShare = (e) => {
    const url = window.location.origin + audioSrc555;
    navigator.clipboard.writeText(url).then(() => {
      alert("URL copied now you can share");
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  const interviewshandleSkip = (seconds) => {
    const newTime = Math.min(Math.max(interviewsaudioRef.current.currentTime + seconds, 0), duration55); // Changed variable name
    interviewsaudioRef.current.currentTime = newTime;
    setCurrentTime55(newTime); // Changed variable name
  };

  const interviewsformatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <div className="audio-player ">

      <div className="flex justify-center mb-4">
        <button
          onClick={interviewstogglePlayPause}
          className="play-btn bg-blue-500 hover:bg-[#e6ff00] text-white font-bold py-2 px-4 rounded-full"
        >
          {interviewsisPlaying ? <Pause size={28} /> : <Play size={28} />}
        </button>
      </div>

      <div className="flex justify-around items-center" style={{ margin: "20px 0px" }}>
        {/* <button style={{color:"#D9EE15"}} onClick={interviewshandleinterviewsspeedChange} className=" font-bold py-2 px-4 rounded">
            {interviewsspeed}x
          </button> */}
        <button
          style={{ color: "#D9EE15" }}
          onClick={() => setShowDropdown(!showDropdown)}
          className="text-white text-sm font-bold py-2 px-4 rounded"
        >
          {interviewsspeed}x
        </button>
        {showDropdown && (
          <div
            style={{ backgroundColor: "#d9ee1591", color: "white", padding: "5px", marginLeft: "-288px", marginBottom: "200px" }}
            className="absolute mt-2 rounded shadow-lg"
          >
            {interviewsspeedOptions.map((option) => (
              <div key={option}>
                <button
                  onClick={() => interviewshandleinterviewsspeedChange(option)}
                  className="block w-full text-left px-4 py-2"
                  style={{
                    // backgroundColor: "#d9ee1591",
                    color: "#161414",
                    width: "80px",
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #161414",
                  }}
                >
                  <span>{option}x</span> <span className="text-xl font-bold">{option === interviewsspeed && "✓"}</span>
                </button>
              </div>
            ))}
          </div>
        )}
        <button style={{ color: "#D9EE15" }} onClick={() => interviewshandleSkip(-30)} className=" text-xl font-bold py-2 px-4 rounded">
          <RiReplay30Fill />
        </button>

        <button style={{ color: "#D9EE15" }} onClick={() => interviewshandleSkip(30)} className=" text-xl font-bold py-2 px-4 rounded">
          <RiForward30Line />
        </button>

        <button style={{ color: "#D9EE15" }} onClick={() => interviewshandleShare()} className=" text-xl font-bold py-2 px-4 rounded">
          <IoShareSocialOutline />
        </button>
      </div>
      <hr className="My-audio-payer-hr" />

      <div className="mb-4 my-range-input-of-audio-player">
        <input
          type="range"
          min="0"
          max="100"
          value={(currentTime55 / duration55) * 100 || 0} // Changed variable name
          onChange={interviewshandleSeek}
          className="seek-bar w-full"
          style={{
            backgroundImage: `linear-gradient(#d9ee15,#d9ee15)`,
            backgroundSize: `${(currentTime55 / duration55) * 100}% 100%`, // Changed variable name
            backgroundRepeat: "no-repeat"
          }}
        />
        <div className="flex justify-between text-white text-sm mt-1" style={{ width: "100%" }}>
          <span style={{ color: "#D9EE15" }}>{interviewsformatTime(currentTime55)}</span> {/* Changed variable name */}
          <span style={{ color: "#D9EE15" }}>{interviewsformatTime(duration55)}</span> {/* Changed variable name */}
        </div>
      </div>

    </div>
  );
};

export default AudioPlayer2;
